import { Component } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ModalComponent, ModalService } from "src/app/services/modal.service";

/** Class that contains the confirmation dialog specific data
 * E.g. `title` of the dialog or `content` of the dialog in form string
 */
export class ConfirmationDialogData {
  title: string;
  content: string[];
  isOnlyNotificationModal: boolean = false;

  constructor(dialogTitle: string, dialogContent: string[], isOnlyNotificationModal = false) {
    this.title = dialogTitle;
    this.content = dialogContent;
    this.isOnlyNotificationModal = isOnlyNotificationModal;
  }
}

@Component({
  selector: "app-confirmation-dialog-modal",
  templateUrl: "./confirmation-dialog-modal.component.html",
  styleUrls: ["./confirmation-dialog-modal.component.scss"],
  standalone: false,
})
export class ConfirmationDialogModalComponent
  implements ModalComponent<ConfirmationDialogModalComponent, ConfirmationDialogData, boolean>
{
  readonly localizationConstants = LocalizationConstants;
  title: string = "";
  content: string[] = [];
  isOnlyNotificationModal: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogModalComponent, boolean>,
    private modalService: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
  ) {
    this.title = this.data.title;
    this.content = this.data.content;
    this.isOnlyNotificationModal = this.data.isOnlyNotificationModal;
  }

  onDialogCloseClick() {
    this.modalService.close();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
